import { render, staticRenderFns } from "./BuscarCobrancas.vue?vue&type=template&id=31a1f7c5&scoped=true"
import script from "./BuscarCobrancas.vue?vue&type=script&lang=js"
export * from "./BuscarCobrancas.vue?vue&type=script&lang=js"
import style0 from "./BuscarCobrancas.vue?vue&type=style&index=0&id=31a1f7c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a1f7c5",
  null
  
)

export default component.exports